(() => {
  const NB_HYPHEN = "\u2011"; // non-breaking hyphen
  const rx = /\b(\d{2,6})-(\d{1,4})\b/g;

  function fix(root = document) {
    // Cible d'abord les zones probables de titres produits
    const selectors = [
      '.grid-product__title',
      '.product-grid-item__title',
      '.product-card__title',
      '.card__heading',
      'h2 a', 'h3 a', 'h4 a'
    ];

    let nodes = [];
    selectors.forEach(sel => nodes.push(...root.querySelectorAll(sel)));

    // Fallback : si aucun match, on scanne les liens de produits
    if (!nodes.length) {
      nodes = Array.from(root.querySelectorAll('a[href*="/products/"]'));
    }

    nodes.forEach(el => {
      // On évite de casser des éléments avec sous-HTML complexe
      if (el.children && el.children.length) return;

      const t = el.textContent;
      if (!t || !rx.test(t)) return;

      el.textContent = t.replace(rx, `$1${NB_HYPHEN}$2`);
    });
  }

  function run() {
    // On applique tout de suite
    fix(document);

    // Et on ré-applique si la grille se réinjecte (infinite scroll / ajax)
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (n && n.nodeType === 1) fix(n);
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
